// extracted by mini-css-extract-plugin
export default {"blockMessage":"BlockMessage-module__[local]___Jw9tj"};